export default "__VITE_ASSET__03d38302__"